<template>
	<div
		:class="[
			'flex justify-center items-center rounded-full bg-blue-400',
			defaultFetchedImg,
			customClass
		]"
	>
		<!-- PEOPLE   -->
		<div v-if="people" class="items-center">
			<img
				v-if="imgUrl"
				:src="imgUrl"
				class="rounded-full"
				alt=""
				:class="defaultFetchedImg"
			/>

			<!-- DEFAULT IMAGE -->
			<img v-else src="@/assets/svg/person.svg" :class="defaultImg" alt="" />
		</div>

		<!-- PRODUCTS -->
		<div v-else class="items-center">
			<img v-if="imgUrl" :src="imgUrl" class="rounded-full" alt="" />
			<span v-else class="text-gray-50" :class="defaultText">{{
				indexTitle
			}}</span>
		</div>
	</div>
</template>

<script>
export default {
	props: ["title", "size", "people", "imgUrl", "customClass"],
	name: "Avatar",
	data() {
		return {
			//   title: "efueling revamp site",
			//   people: false,
			//   size: "HeadMed",
			//   imgUrl: null,
			//   imgUrl:
			//     "https://plus.unsplash.com/premium_photo-1683865776032-07bf70b0add1?q=80&w=1932&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
		};
	},

	computed: {
		indexTitle() {
			const words = this.title.split(" ");
			const initials = words
				.slice(0, 2)
				.map(word => word.charAt(0).toUpperCase());
			return initials.join("");
		},
		defaultImg() {
			return {
				"size-6": this.size === "HeadMed",
				"size-5": this.size === "HeadSmall",
				"size-4": this.size === "LabelMed",
				"size-3": this.size === "LabelSmall",
				"size-8": this.size === "DisplayMed",
				"size-7": this.size === "DisplaySmall"
			};
		},
		defaultFetchedImg() {
			return {
				"size-16": this.size === "HeadMed",
				"size-12": this.size === "HeadSmall",
				"size-9": this.size === "LabelMed",
				"size-7": this.size === "LabelSmall",
				"size-28": this.size === "DisplayMed",
				"size-20": this.size === "DisplaySmall"
			};
		},
		defaultText() {
			return {
				"leading-9 text-xl": this.size === "HeadMed",
				"leading-7 text-sm": this.size === "HeadSmall",
				"leading-5 text-xs": this.size === "LabelMed",
				"leading-4 text-xs": this.size === "LabelSmall",
				"leading-10 text-5xl": this.size === "DisplayMed",
				"leading-9 text-4xl": this.size === "DisplaySmall"
			};
		}
	},

	methods: {}
};
</script>

<style></style>
